import { Card, CardBody, Col, Row } from "reactstrap";
import { H2, H3, Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { useEffect, useState } from "react";
import api from "../../../../utils/api";
// import { totalStudentData } from "../../../../Data/Dashboard/EducationData";

// interface GrandAmountData {
//   totalGrandAmount: number;
//   monthlyGrandAmount: number;
//   todayGrandAmount: number;
// }

// interface TotalStudentData {
//   locker: GrandAmountData;
//   cloth: GrandAmountData;
//   food: GrandAmountData;
// }


interface StudentData {
  totalGrandAmount: number;
  monthlyGrandAmount: number;
  todayGrandAmount: number;
  counterType: string;
}

const TotalStudents = () => {
  const [totalStudentData, setTotalStudentData] = useState<StudentData[]>([]);
  const userId = JSON.parse(localStorage.getItem("user")!).userId;
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Replace with your actual API endpoint
        const response = await api.get("/api/DashboardReport/GetDashboardReport?UserId="+userId);
        // const data = response.data.dashboardReport;
        setTotalStudentData(response.data.dashboardReport);
      } catch (error) {
        // console.error("Error fetching total student data:", error);
      }
    };
    fetchData();
  }, []);
  // const initialTotalStudentData: TotalStudentData[] = [
  //   {
  //     locker: {
  //       totalGrandAmount: 13846,
  //       monthlyGrandAmount: 1270,
  //       todayGrandAmount: 0,
  //     },
  //     cloth: {
  //       totalGrandAmount: 56802,
  //       monthlyGrandAmount: 56802,
  //       todayGrandAmount: 0,
  //     },
  //     food: {
  //       totalGrandAmount: 2200,
  //       monthlyGrandAmount: 0,
  //       todayGrandAmount: 0,
  //     },
  //   },
  // ];
  return (
    <>
      {totalStudentData.length > 0 && (
        <Col xl="12" md="12" className="proorder-md-1">
          <Row>
            {totalStudentData.map((data, index) => (
              <>
              {data?.counterType !== "Card Assign" && data?.counterType !== "Card Recharge" ?
                <Col xl="4" sm="6" key={`${index}-total`}>
                  <Card className={`income-card income-card-${index}`}>
                    <CardBody className='student'>
                      <div className="d-flex gap-2 align-items-end">
                        <div className="flex-grow-1">
                          {/* {data?.counterType === "Card Assign" ? <>
                          <H3><span style={{fontSize: 14}}>Total Cards Assign - </span> {data.totalGrandAmount}</H3>
                          <H3><span style={{fontSize: 14}}>Monthly Cards Assign - </span> {data.monthlyGrandAmount}</H3>
                          <H3><span style={{fontSize: 14}}>Today Cards Assign - </span> {data.todayGrandAmount}</H3>
                          </> :
                          <> */}
                          <H3><span style={{fontSize: 14}}>Total Income - </span> ₹ {data.totalGrandAmount}</H3>
                          <H3><span style={{fontSize: 14}}>Monthly Income - </span>₹ {data.monthlyGrandAmount}</H3>
                          <H3><span style={{fontSize: 14}}>Today Income - </span>₹ {data.todayGrandAmount}</H3>
                          {/* </>
                          } */}
                          <P className="mb-0 mt-2" style={{fontSize: 14}}>
                            {data?.counterType}
                          </P>
                        </div>
                        <div className="flex-shrink-0">
                          <Image
                            src={dynamicImage(`dashboard-3/icon/coin1.png`)}
                            alt="student"
                          />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              : '' 
              }
                {/* <Col xl="4" sm="6" key={`${key}-monthly`}>
                  <Card className={`income-card income-card-${key}`}>
                    <CardBody className='student-2'>
                      <div className="d-flex gap-2 align-items-end">
                        <div className="flex-grow-1">
                          <H2>Rs. {data.monthlyGrandAmount}</H2>
                          <P className="mb-0">
                            {key === "locker" && "Monthly Locker Income"}
                            {key === "cloth" && "Monthly Cloth Income"}
                            {key === "food" && "Monthly Food Income"}
                          </P>
                        </div>
                        <div className="flex-shrink-0">
                          <Image
                            src={dynamicImage(`dashboard-3/icon/coin1.png`)}
                            alt="student"
                          />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
                <Col xl="4" sm="6" key={`${key}-today`}>
                  <Card className={`income-card income-card-${key}`}>
                    <CardBody className='student-3'>
                      <div className="d-flex gap-2 align-items-end">
                        <div className="flex-grow-1">
                          <H2>Rs. {data.todayGrandAmount}</H2>
                          <P className="mb-0">
                            {key === "locker" && "Today's Locker Income"}
                            {key === "cloth" && "Today's Cloth Income"}
                            {key === "food" && "Today's Food Income"}
                          </P>
                        </div>
                        <div className="flex-shrink-0">
                          <Image
                            src={dynamicImage(`dashboard-3/icon/coin1.png`)}
                            alt="student"
                          />
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col> */}
              </>
            ))}
          </Row>
        </Col>
      )}
    </>
  );
};

export default TotalStudents;
